export default __webpack_public_path__ + "static/media/money.6de59ab8.svg";